import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './styles/global.css';
import { installWhatsAppDirect } from './lib/whatsappDirect';

// WhatsApp buttons open WhatsApp itself, never WhatsApp's grey page (Gary, 31 Oct 2026).
installWhatsAppDirect();

// If an old service worker served the SPA shell at a public static HTML
// path (certificate.html, pos-certificate.html), unregister it and reload
// so the browser fetches the real standalone page directly.
// Guards against infinite loops with sessionStorage.
// Old plaque.html / plaque-verify.html / pos-certificate-verify.html URLs
// are kept for transitional SW recovery — Netlify 301-redirects them to
// the new paths after recovery reloads.
const PUBLIC_STATIC_PATHS = new Set([
  '/certificate.html',
  '/pos-certificate.html',
  '/plaque.html',
  '/plaque-verify.html',
]);
if (PUBLIC_STATIC_PATHS.has(window.location.pathname) && !sessionStorage.getItem('sw-recovery-attempted')) {
  sessionStorage.setItem('sw-recovery-attempted', '1');
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      Promise.all(regs.map((r) => r.unregister())).finally(() => {
        window.location.reload();
      });
    });
  } else {
    window.location.reload();
  }
} else {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
}
